// Pure: what a quote item's "Add to / Copy to invoice" button offers
// (Stephanie 2026-10-19). No app imports, so the offline gate can run it.

export interface InvoiceTargets {
  ownInvoice: { invoiceId: string; invoiceNumber: number; changed: boolean; block: string | null; newLineIds: string[] } | null;
  others: Array<{ invoiceId: string; invoiceNumber: number; orderNumber: number; block: string | null }>;
  canCopy: boolean;
}

/** Pure: what the button offers for this item (null = no button). */
export function invoiceChoicesFor(
  t: InvoiceTargets | undefined,
  line: { id: string; serviceType: string; billedOnInvoiceNumber?: number | null },
): { kind: "add"; invoiceId: string; invoiceNumber: number } | { kind: "copy"; options: Array<{ invoiceId: string; invoiceNumber: number; orderNumber: number }>; waitingOnJake: boolean } | null {
  if (!t || line.billedOnInvoiceNumber) return null;
  const own = t.ownInvoice;
  if (own) {
    // This quote is invoiced: only items added since, while the invoice can still change.
    return own.newLineIds.includes(line.id) && !own.block ? { kind: "add", invoiceId: own.invoiceId, invoiceNumber: own.invoiceNumber } : null;
  }
  if (line.serviceType !== "product") return null;
  const options = t.others.filter((o) => !o.block).map(({ invoiceId, invoiceNumber, orderNumber }) => ({ invoiceId, invoiceNumber, orderNumber }));
  return options.length ? { kind: "copy", options, waitingOnJake: !t.canCopy } : null;
}


/** Pure: can this item come off the quote AND its invoice (Stephanie
 *  2026-10-29)? Only on an invoiced quote whose invoice can still change, and
 *  only items already on the invoice (newer ones are simply not added). */
export function removeFromInvoiceFor(
  t: InvoiceTargets | undefined,
  line: { id: string },
): { invoiceNumber: number } | null {
  const own = t?.ownInvoice;
  if (!own || own.block || own.newLineIds.includes(line.id)) return null;
  return { invoiceNumber: own.invoiceNumber };
}
